window.switchLang = function(url) {
    $.ajax({
        type: 'GET',
        url: url,
        success: function (response) {
            reloadPageAfterSwitchingLanguage();
        },
        error: function (response) {
            reloadPageAfterSwitchingLanguage();
        }
    });
}

window.reloadPageAfterSwitchingLanguage = function() {
    let url = window.location.href;
    if (url.indexOf("?") != -1 || /\d/.test(url)) {
        if (url.indexOf("/admin") != -1) {
            location.href = '/admin';
        } else {
            location.href = '/courses';
        }
    } else {
        location.reload();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/language_switcher.js